import React, { ReactElement } from "react";
import { Dropdown } from "react-bootstrap";
import { IoEllipsisVertical } from "react-icons/io5";
import classNames from "classnames";
import { RiMoreFill } from "@remixicon/react";
import { Permission } from "../../../__generated__/api";
import useCurrentSession from "../../../contexts/session";
import CreateAnswerAction from "./create-answer";
import EditMessageAction from "./edit";
import DeleteMessageAction from "./delete";
import Styles from "../Chat.module.scss";
import { useTheme } from "../../../contexts/Theme";
import { TicketItem } from "../../../contexts/ticket-state";
import RedactMessageAction from "./redact";

export default function CardActions({
    isAgentMessage, messageText, plainText, isHover, messageId,
    isEditable, isDeletable, ticketItem, isRedacted,
}: {
    isAgentMessage: boolean, messageText: string, plainText?: string, isHover?: boolean,
    messageId: string, isEditable: boolean, isDeletable: boolean, isRedacted: boolean, ticketItem?: TicketItem
}): ReactElement {
    // const [target, setTarget] = useState<HTMLElement>();
    const { permissions } = useCurrentSession();
    const theme = useTheme();
    return (
        <>
            {/* {target && (
                <EmojiPicker
                    target={target}
                    chatId={chatId}
                    messageId={messageId}
                    onHide={() => setTarget(undefined)}
                    placement={isAgentMessage ? "right" : "left"}
                />
            )} */}
            <div className={theme.isV3
                ? classNames(
                    Styles["card-action"],
                    isHover ? Styles["card-action-hover"] : undefined,
                    isAgentMessage ? Styles["card-action-agent"] : Styles["card-action-user"],
                    "card-actions",
                )
                : classNames(
                    `position-absolute top-0 bg-blue-dark rounded mt-n1`,
                    isAgentMessage ? "start-0" : "translate-middle-x start-100 ms-n4",
                    isHover ? "d-flex" : "d-none",
                // eslint-disable-next-line react/jsx-indent
                )}
            >
                {/* <button
                    className="badge btn btn-none py-2 px-2 text-light"
                    type="button"
                    onClick={evt => {
                        setTarget(target ? undefined : evt.currentTarget);
                    }}
                >
                    <BsEmojiSunglasses />
                </button> */}
                {!isRedacted && (permissions.has(Permission.ArticleModify) || permissions.has(Permission.Administrator)) && (
                    <Dropdown>
                        <Dropdown.Toggle
                            variant=""
                            size="sm"
                            className={theme.isV3 ? Styles["menu-toggle"] : "menu-small text-white btn btn-sm p-1 px-2"}
                        >
                            {theme.isV3 ? <RiMoreFill /> : <IoEllipsisVertical />}

                        </Dropdown.Toggle>
                        <Dropdown.Menu className={theme.isV3
                            ? Styles["menu-container"]
                            : `bg-blue-dark text-white dropdown-dark`}
                        >

                            {isEditable && isDeletable && (
                                <EditMessageAction
                                    ticketMessageId={messageId}
                                />
                            )}
                            {isDeletable && (
                                <DeleteMessageAction
                                    text={messageText}
                                    ticketMessageId={messageId}
                                    ticketItem={ticketItem}
                                />
                            )}
                            <RedactMessageAction
                                text={plainText as string}
                                ticketMessageId={messageId}
                                ticketItem={ticketItem}
                            />
                            <Dropdown.Divider />

                            <CreateAnswerAction text={messageText} plainText={plainText} />
                        </Dropdown.Menu>
                    </Dropdown>
                )}
            </div>
        </>
    );
}

CardActions.defaultProps = {
    plainText: "",
    isHover: true,
    ticketItem: undefined,
};
